import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import {
  AccountBalanceWallet,
  AccountCircle,
  Beenhere,
  Category,
  Email,
  ExitToApp,
  Face,
  Help,
  Home,
  HomeWork,
  Info,
  LiveHelp,
  Lock,
  LockOpen,
  MonetizationOn,
  People,
  Public,
  QuestionAnswer,
  ThumbUp,
  ViewList,
  Work,
} from '@material-ui/icons'

import Button from 'components/CustomButtons/Button.js'

import styles from 'assets/jss/material-kit-react/components/headerLinksStyle.js'
import { setAccessToken } from 'redux/actions/accountActions'
import { setAccount } from 'redux/actions/accountActions'
import CustomDropdown from 'components/CustomDropdown/CustomDropdown'
import { getAuth, signOut } from 'firebase/auth'
import { useEffect, useState } from 'react'
import { getStorageAccount } from 'redux/actions/accountActions'
import { setCurrentRoom } from 'redux/actions/messagesActions'
import { setShowChat } from 'redux/actions/harmonizeActions'
import { setReactorPlay } from 'redux/actions/displayActions'
import { isAdminUser } from 'util/adminUtils'
import { setCurrentRoomOwner } from 'redux/actions/messagesActions'
import { setStudios } from 'redux/actions/accountActions'
import { coreServiceSignOut } from 'controllers/CoreServiceController'
import { reset } from 'util/playlistUtils'
import harmonizeWhiteIcon from 'assets/img/harmonize-white-icon.png'
import { setPreview } from 'redux/actions/playerControlActions'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'
import { setPlayerMode } from 'redux/actions/harmonizeActions'
import { setCurrentCredits } from 'redux/actions/creditsActions'
import { setContinuousPlay } from 'redux/actions/displayActions'
import { setQuery } from 'redux/actions/fetchActions'
import { resetAccount } from 'redux/actions/accountActions'

const useStyles = makeStyles(styles)

export default function HeaderLinks() {

  const account = getStorageAccount()
  const { handle, providerId } = account ? account : { handle: null, providerId: null }
  const { isArtist, signedIn, studios } = useSelector(state => state.account)
  const iconColor = 'white'
  const [startSignOut, setStartSignOut] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const classes = useStyles()
  const iconStyle = classes.icons

  const dropdownLinks = isArtist ? [
    <Link to='/MyProfile' className={classes.navLink}>
      <Face className={iconStyle} /> My Profile
    </Link>,

    <Link to='/Subscribers' className={classes.navLink}>
      <People className={iconStyle} /> Subscribers
    </Link>,
    <Link to='/Vault' className={classes.navLink}>
      <AccountBalanceWallet className={iconStyle} /> Vault
    </Link>,

    <Button
      color='transparent'
      onClick={() => setStartSignOut(true)}
      className={classes.navLink}
    >
      <ExitToApp className={iconStyle} /> Sign Out
    </Button>
  ] : [
    <Link to='/MyProfile' className={classes.navLink}>
      <Face className={iconStyle} /> My Profile
    </Link>,

    <Link to='/Vault' className={classes.navLink}>
      <AccountBalanceWallet className={iconStyle} /> Vault
    </Link>,

    <Button
      color='transparent'
      onClick={() => setStartSignOut(true)}
      className={classes.navLink}
    >
      <ExitToApp className={iconStyle} /> Sign Out
    </Button>
  ]
  if (isAdminUser()) {
    dropdownLinks.push(<Link to='/admin/ManageApprovals' className={classes.navLink}>
      <Beenhere className={iconStyle} /> Approvals
    </Link>)
  }


  const accountSignOut = async () => {
    console.log(`accountSignOut providerId ${providerId}`)

    dispatch(resetAccount())
    setAccessToken(null)
    setAccount(null)
    dispatch(setPreview(true))
    dispatch(setCurrentRoom(null))
    dispatch(setCurrentRoomOwner(null))
    dispatch(setStudios([]))
    dispatch(setShowChat(false))
    dispatch(setReactorPlay(false))
    dispatch(setCurrentCredits(0))

    history.replace('/')
    //window.location.reload()

    try {
      await coreServiceSignOut()
    } catch (error) {
      console.error('Unable to sign out from Core Service', error)
    }
    if (providerId) {
      const auth = getAuth()
      signOut(auth)
        .then(() => {
          console.log('Signed out provider')
        })
        .catch((error) => {
          console.error(`Unable to sign out provider ${providerId}`, error)
        })
    }
  }

  useEffect(() => {

    if (startSignOut) {
      accountSignOut()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startSignOut])

  /**
   * The window reload is required to force the Studio component to reload.
   * @param {*} studioName 
   */
  const resetForStudioHome = (studio) => {
    console.log('HeaderLinks studio', studio)
    dispatch(setQuery(null))
    dispatch(setCurrentRoom(studio, 1))
    dispatch(setPlayerMode(PLAYER_MODES.SWIPE))
    dispatch(setContinuousPlay(false))

    const { name } = studio
    history.push(`/@${handle}/${name}`)
    window.location.reload()
  }

  const getDraftsLink = () => {
    const drafts = studios.find(s => s.name === 'private')
    if (drafts) {
      return <ListItem className={classes.listItem}>
        <div onClick={() => resetForStudioHome(drafts)} className={classes.navLink}>
          <ViewList className={iconStyle} /> My Drafts
        </div>

      </ListItem>
    }
  }
  const getHomeLink = () => {
    if (signedIn) {
      const home = studios.find(s => s.name === 'home')
      return <ListItem className={classes.listItem}>
        <div onClick={() => resetForStudioHome(home)} className={classes.navLink}>
          <Home className={iconStyle} /> My Home
        </div>
      </ListItem>
    } else {
      return <ListItem className={classes.listItem}>
        <Link to='/SignIn' className={classes.navLink}>
          <LockOpen className={iconStyle} /> Sign In
        </Link>
      </ListItem>
    }
  }
  const getPublicLink = () => {
    const publicStudio = studios.find(s => s.name === 'public')
    if (publicStudio) {
      return <ListItem className={classes.listItem}>
        <div onClick={() => resetForStudioHome(publicStudio)} className={classes.navLink}>
          <Public className={iconStyle} /> My Public
        </div>

      </ListItem>
    }
  }
  return (
    <List className={classes.list} >
      {process.env.REACT_APP_INTRODUCTION !== 'true' ? <ListItem className={classes.listItem}>
        <Link to='/' className={classes.navLink} onClick={() => reset(dispatch)}>
          <img
            alt='Harmonize'
            src={harmonizeWhiteIcon}
            className={iconStyle}

          /> Harmonize
        </Link>
      </ListItem> : null}
      {getHomeLink()}
      {getDraftsLink()}
      {getPublicLink()}
      {signedIn && (
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            buttonText='Account'
            buttonProps={{
              className: classes.navLink,
              color: 'transparent',
            }}
            buttonIcon={AccountCircle}
            iconColor={iconColor}
            dropdownList={dropdownLinks}
          />
        </ListItem>
      )}
      <ListItem className={classes.listItem}>
        <Link to='/Introduction' className={classes.navLink}>
          <QuestionAnswer className={iconStyle} /> Introduction
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to='/Pricing' className={classes.navLink}>
          <MonetizationOn className={iconStyle} /> Pricing
        </Link>
      </ListItem>


      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText='Help'
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={Help}
          iconColor={iconColor}
          dropdownList={[
            <ListItem className={classes.listItem}>
              <Link to='/About' className={classes.navLink}>
                <Info className={iconStyle} /> About
              </Link>
            </ListItem>,
            <ListItem className={classes.listItem}>
              <Link to='/help/AboutStudios' className={classes.navLink}>
                <HomeWork className={iconStyle} /> Studios
              </Link>
            </ListItem>,
            <ListItem className={classes.listItem}>
              <Link to='/help/FAQ' className={classes.navLink}>
                <LiveHelp className={iconStyle} /> FAQ
              </Link>
            </ListItem>,

            <ListItem className={classes.listItem}>
              <Link to='/help/Approvals' className={classes.navLink}>
                <Beenhere className={iconStyle} /> Approvals
              </Link>
            </ListItem>,
            <ListItem className={classes.listItem}>
              <Link to='/Contact' className={classes.navLink}>
                <Email className={iconStyle} /> Contact
              </Link>
            </ListItem>
          ]}
        />
      </ListItem>

      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText='Policies'
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={Category}
          iconColor={iconColor}
          dropdownList={[
            <Link to='/Credits' className={classes.navLink}>
              <ThumbUp className={iconStyle} /> Credits
            </Link>,

            <Link to='/Privacy' className={classes.navLink}>
              <Lock className={iconStyle} /> Privacy
            </Link>,
            <Link to='/TermsOfService' className={classes.navLink}>
              <Work className={iconStyle} /> Terms of Service
            </Link>,

          ]}
        />
      </ListItem>

    </List>
  )
}

